module.exports = __webpack_public_path__ + "img/profile-logo-signup-selection.909a292d.svg";